import Schedule from './Schedule';
import ScheduleTick from './ScheduleTick';

const strftime = require('strftime');
export default class Day {
	get schedule() {
		return new Schedule({
			begin: new ScheduleTick({code: this.code + ScheduleTick.TERM.AM}),
			end: new ScheduleTick({code: this.code + ScheduleTick.TERM.PM}),
		});
	}

	constructor(params) {
		this.code = params.code;
		this.day = this.code.substr(6, 2),
		this.weekDayNum = params.weekDayNum;
		this.holiday = params.holiday;
	}

	isToday() {
		let today = new Date(Date.today);
		return this.code === strftime('%Y%m%d', today);
	}
	
	isHoliday() {
		return (this.holiday != null);
	}
	
	getHolidayName(){
		return this.holiday.name;
	}
}
